<template>
    <div>
        <div v-if="loading">
            <v-progress-linear
            indeterminate
            color="primary"
            ></v-progress-linear>
        </div>
        <v-card>
            <v-card-title>Edit Vanglaini Thlalak</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-form ref="form" v-model="isValid">
                    <v-text-field
                        filled
                        label="Photographer's name"
                        v-bind:rules="validation.photographer_name"
                        v-model="serverData.photographer_name"
                    ></v-text-field>
                    <br>
                    <v-textarea
                        rows="3"
                        filled
                        label="Address"
                        v-model="serverData.address"
                    >
                    </v-textarea>
                    <v-textarea
                        rows="4"
                        filled
                        label="Description"
                        v-model="serverData.description"
                    >
                    </v-textarea>
                    <v-file-input
                        filled
                        label="Photo"
                        accept="image/*"
                        prepend-icon="mdi-camera"
                        v-model="serverData.photo"
                        show-size
                        counter
                    ></v-file-input>
                    <v-card >
                        <div v-if="serverImageObject !== null">
                                <v-container fluid grid-list-md tile>
                                    <!-- xs = 600px full screen (12) -->
                                    <!-- md = 600px or more. half of the screen (6) -->
                                    <v-layout row wrap>
                                        <v-flex xs12 md6>
                                            <image-card :image="serverImageObject" :id="serverImageObject.id" @delete_success="callbackImgDeleteSuccess"/>
                                        </v-flex>
                                    </v-layout>
                            </v-container>
                        </div>
                        <v-card-subtitle v-else>No uploaded Image</v-card-subtitle>
                    </v-card>
                    <br>
                    <v-text-field
                      label="Select publish date"
                      filled
                      clearable
                      readonly
                      v-model="formattedDate"
                      @click:clear="dateClearCallback"
                      prepend-icon="mdi-calendar"
                      @click="showDatePicker"
                    ></v-text-field>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>

                <v-btn
                    tile
                    color="primary"
                    class="mx-2"
                    v-on:click="update"
                    v-bind:disabled="!isValid"
                    v-bind:loading="loading"
                    >Update</v-btn
                >
                <v-spacer />
            </v-card-actions>
        </v-card>
        <DatePickerDialog @dateSelected="dateSelectionCallback" :visible="showDatePickerDialog" @close="showDatePickerDialog=false"></DatePickerDialog>

    </div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import vtApi from '@/api/vtApi'
import snackbar from '@/utils/snackbar'
import dateUtils from '@/utils/dateUtils'
import DatePickerDialog from '@/components/DatePickerDialog'
import urlUtils from '@/utils/urlUtils'
import * as dateFormats from '@/constants/dateFormats'

export default {
  components: {
    DatePickerDialog,
    'image-card': () => import('@/components/ImageDeleteCard')
  },
  props: {
    title: {
      type: String,
      default: 'Add News'
    }
  },
  mounted () {
    this.fetchVT()
  },

  data () {
    return {
      isValid: null,
      imageData: '',
      loading: false,
      formattedDate: null,
      showDatePickerDialog: false,
      serverImageObject: null,
      serverData: {
        id: null,
        photographer_name: '',
        address: '',
        description: null,
        publish_date: null,
        photo: null
      },
      validation: {
        photographer_name: [(v) => !!v || 'Photographer\'s name is required'],
        address: [(v) => !!v || 'Address is required']
      },
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'link'],
            [{ header: 1 }, { header: 2 }],
            [{ align: [] }],
            ['clean'],
            [{ list: 'ordered' }, { list: 'bullet' }]]
        },
        placeholder: 'Body'
      }
    }
  },
  methods: {
    async fetchVT () {
      try {
        this.loading = true
        const response = await vtApi.getById(this.$route.params.id)
        this.$log.info('response vt', [response.data])
        if (response.data !== undefined) {
          if (response.data.id !== undefined) {
            this.assignValues(response)
          }
        }
      } finally {
        this.loading = false
      }
    },
    assignValues (response) {
      this.serverData.id = response.data.id
      this.serverData.photographer_name = response.data.photographer_name
      this.serverData.address = response.data.address
      this.serverData.description = response.data.description
      this.serverData.publish_date = response.data.publish_date
      this.formattedDate = this.$moment(this.serverData.publish_date).format(dateFormats.DDMMYY)

      if (response.data.image !== undefined) {
        this.serverImageObject = response.data.image
      }
    },
    callbackImgDeleteSuccess () {
      this.fetchVT()
    },
    getImageFullUrl (url) {
      var k = urlUtils.getImageUrl(url)
      return k
    },
    dateClearCallback () {
      this.$log.info('date clear callback')
      this.serverData.publish_date = null
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.serverData.publish_date = dateUtils.parseDate(data)
    },
    showDatePicker () {
      this.showDatePickerDialog = true
    },
    async update () {
      this.loading = true
      try {
        this.$log.info('vThlalak submit params', [this.serverData])
        const response = await vtApi.update(this.serverData)
        if (response.data !== undefined) {
          this.assignValues(response)
          snackbar.show('Vanglaini thlalak updated successfully', 'success')
          window.publish_date = this.serverData.publish_date
          this.$router.push({ path: '/vanglaini-thlalak', replace: true })
        }
      } finally {
        this.loading = false
      }
    },
    onEditorBlur (quill) {
    },
    onEditorFocus (quill) {
    },
    onEditorReady (quill) {
    },
    onEditorChange ({ quill, html, text }) {
      this.content = html
    }
  }
}
</script>

<style>
.ql-editor{
  min-height: 350px;
}
</style>
